import { PrefixedUnion, createMediaPropertyMap } from './mediaProperties'
import { resolveSizeValues } from './resolveSizeValues'
import { Size } from './size'

const paddingPropKeys = ['p', 'pt', 'pr', 'pb', 'pl'] as const

type PaddingKeyProps = (typeof paddingPropKeys)[number]

const paddingPropsCssMap: Record<PaddingKeyProps, string> = {
  ['p']: 'padding',
  ['pt']: 'padding-top',
  ['pr']: 'padding-right',
  ['pb']: 'padding-bottom',
  ['pl']: 'padding-left'
}

export type PaddingMediaKeys = PaddingKeyProps | PrefixedUnion<'sm', PaddingKeyProps>
export type PaddingProps = Partial<Record<PaddingMediaKeys, number | Size>>

export const padding = (props: PaddingProps) => resolveSizeValues(props, paddingPropsCssMap)
export const smPadding = (props: PaddingProps) =>
  resolveSizeValues(props, createMediaPropertyMap(paddingPropsCssMap, 'sm'))
